export const API_PARTS = {
    API_VERSION: '/api/v1',
    ADMIN: 'admin',
    USERS: 'users',
    USER: 'user',
    HEALTH: 'health',
    RESULTS: 'results',
};

export const USER_REQUEST_CHANGES_STATUSES = {
    PENDING: 'pending',
    REJECTED: 'rejected',
    ACCEPTED: 'accepted',
};

export const CONTENT_TYPE_FORM_DATA_HEADER = {
    'Content-Type': 'multipart/form-data',
};

export const OK_STATUS_CODE = 200;
export const BAD_REQUEST_STATUS_CODE = 400;
export const UNAUTHORIZED_STATUS_CODE = 401;
export const FORBIDDEN_STATUS_CODE = 403;
export const NOT_FOUND_STATUS_CODE = 404;
export const CONFLICT_STATUS_CODE = 409;
export const UNPROCESSABLE_CONTENT_STATUS_CODE = 422;
export const UNAVAILABLE_LEGAL_REASONS_STATUS_CODE = 451;
export const INTERNAL_SERVER_ERROR_STATUS_CODE = 500;
export const SERVICE_UNAVAILABLE_STATUS_CODE = 503;
export const MAINTENANCE = 'MAINTENANCE';
export const SERVER_ERROR = 'SERVER_ERROR';
export const NETWORK_ERROR = 'NETWORK_ERROR';
export const OTHER = 'OTHER';
export const SERVICE_UNAVAILABLE_MSG = 'Service unavailable (503)';
export const SERVER_ERROR_MSG = 'Server error';
export const UNKNOWN_ERROR_MSG = 'Unknown error';
export const NETWORK_ERROR_MSG = 'Network error';
export const DEFAULT_API_REQUEST_TIMEOUT = 120_000; // 120 seconds
export const NO_REQUEST_TIMEOUT = 0;
